import type { IConfigPortalCredentialRepository } from "@src/domain/repositories/config";
import type { UpdateConfigPortalCredentialDTO } from "@src/domain/dto/config";

export class UpdateConfigPortalCredentialUseCase {
  private readonly repository: IConfigPortalCredentialRepository;

  constructor(repository: IConfigPortalCredentialRepository) {
    this.repository = repository;
  }

  execute(params: UpdateConfigPortalCredentialDTO) {
    return this.repository.updatePortalCredential(params);
  }
}
